module.exports = __webpack_public_path__ + "static/media/evri-coupons.483ee87d.png";